import { CompanyAccountSettings } from "../../model";
import { Ajax, SingleItemApiBase } from "../infra";

/**
 * Provides read / update functionality for main account settings (employer/company)
 */
export class AccountSettings extends SingleItemApiBase<CompanyAccountSettings> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/settings/company";

  constructor(ajax: Ajax) {
    super(ajax);
  }

  /**
   * Creates a new IR certificate.
   * @param transferId Transfer ID for the IR certificate.
   * @param transferPassword One time transfer password for the IR certificate.
   * @returns Information about the created IR certificate.
   */
  public createIrCertificate(transferId: string, transferPassword: string): Promise<any> {
    const url = `/v03/api/settings/irCertificate?transferId=${encodeURIComponent(transferId)}&transferPassword=${encodeURIComponent(transferPassword)}`;
    return this.ajax.postJSON(url,null);
  }

  /**
   * Renews an existing IR certificate.
   * @returns Information about the created IR certificate.
   */
  public renewIrCertificate(): Promise<any> {
    const url = `/v03/api/settings/irCertificate/renew`;
    return this.ajax.postJSON(url,null);
  }

  /**
   * Gets the detials of the existing IR certificate or null if no certificate exists.
   * @returns Information about the current IR certificate.
   */
  public getIrCertificate(): Promise<any> {
    const url = `/v03/api/settings/irCertificate`;
    return this.ajax.getJSON(url);
  }

}
